
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.18 24a.5.5 0 01-.5-.5V2.17a.5.5 0 01.2-.4c3.21-2.4 6.26-1.5 9.21-.63 3.2.94 6.51 1.91 10.43-1.04a.5.5 0 01.8.4v12.06a.5.5 0 01-.2.4c-4.34 3.26-8.05 1.97-11.33.82-2.89-1.01-5.39-1.89-8.11.02v9.7a.5.5 0 01-.5.5zm3.94-12.32a15.44 15.44 0 015 1.15c3.14 1.1 6.38 2.23 10.2-.52V1.46c-3.98 2.56-7.44 1.54-10.5.64-2.9-.85-5.4-1.59-8.14.33v10.18a6.7 6.7 0 013.44-.93z"}})])
          )
        }
      }
    